// Generated by purs version 0.15.15
import * as Ouroboros_Services_FFI_Option from "../Ouroboros.Services.FFI.Option/index.js";
var some = Ouroboros_Services_FFI_Option.some;
var none = Ouroboros_Services_FFI_Option.none;
var map = Ouroboros_Services_FFI_Option.map;
var fold = Ouroboros_Services_FFI_Option.fold;
var chain = function (f) {
    return function (option) {
        return Ouroboros_Services_FFI_Option.chain(option)(f);
    };
};
export {
    some,
    none,
    map,
    chain,
    fold
};
//# sourceMappingURL=index.js.map
